import { useWeeklyCalendar } from '@app/components/Calendars/WeeklyCalendar/hooks/useWeeklyCalendar';

export { useWeeklyCalendar };
